import ErrorScreen from './error_screen'
export default ErrorScreen



// WEBPACK FOOTER //
// ./src/plugins/error_screen/index.js